<script setup lang="ts">
defineProps<{
  prefix?: string
}>()

const article = inject(keys.currentArticle)

const text = computed(() => {
  const tagNames = getTagNamesFromValues(article?.theme)
  return tagNames.join(', ')
})
</script>

<template>
  <p v-if="text" class="max-w-fit bg-(--foreground) px-4 py-1 text-(--background) uppercase">
    {{ prefix }}{{ text }}
  </p>
</template>
